const videoList = [
    {
        id: "04",
        title: "css flexbox em menos de 20 minutos",
        image: "https://img.youtube.com/vi/rvRTNzC_q3c/maxresdefault.jpg",
        link: "https://www.youtube.com/watch?v=rvRTNzC_q3c"
    },
    {
        id: "03",
        title: "next level week 3",
        image: "https://img.youtube.com/vi/5bgL8CeRrAE/maxresdefault.jpg",
        link: "https://www.youtube.com/watch?v=5bgL8CeRrAE"
    },
    {
        id: "02",
        title: "menu responsivo com css, flexbox e javascript",
        image: "https://img.youtube.com/vi/gJ21oN9jFsw/maxresdefault.jpg",
        link: "https://www.youtube.com/watch?v=gJ21oN9jFsw"
    },
    {
        id: "01",
        title: "tipografia responsiva com css",
        image: "https://img.youtube.com/vi/3_RtSaU5hVY/maxresdefault.jpg",
        link: "https://www.youtube.com/watch?v=3_RtSaU5hVY"
    },
]

export default videoList;